// Drop-in replacement for next/image — a plain <img> with the same prop names.
// `priority` and `placeholder` are no-ops in Vite; `width`/`height` are passed
// straight through.

import type { ImgHTMLAttributes } from 'react';

export interface ImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'placeholder'> {
    src: string;
    alt: string;
    width?: number | string;
    height?: number | string;
    priority?: boolean;
    placeholder?: string;
    unoptimized?: boolean;
    fill?: boolean;
}

export default function Image({
    src,
    alt,
    width,
    height,
    priority: _priority,
    placeholder: _placeholder,
    unoptimized: _unoptimized,
    fill,
    style,
    className,
    ...rest
}: ImageProps) {
    const fillStyle = fill
        ? { position: 'absolute' as const, inset: 0, width: '100%', height: '100%', ...style }
        : style;
    return (
        <img
            src={src}
            alt={alt}
            width={width}
            height={height}
            style={fillStyle}
            className={className}
            {...rest}
        />
    );
}
